export const getDefaultPaymentMethod = (paymentMethods) => paymentMethods?.find((paymentMethodProps) => paymentMethodProps.default);
